/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useContext } from 'react';

import PropTypes from 'prop-types';

import VerificationInput from 'react-verification-input';
import { MainContext } from '~/context';

import {
  Container,
  CodeValidatorDescription,
  Form,
  UnblockButton,
  ErrorInfo,
} from './styles';
import './styles.css';

const CodeValidator = ({
  validationKey = {},
  postData,
  width,
  title,
  fontSize,
  height,
  upperCase,
  codeValidator,
}) => {
  const [isEnabled, setAsEnabled] = useState(false);
  const [ref, setRef] = useState(null);
  const [codeLength, setCodeLength] = useState(8);
  const [hasError, setHasError] = useState(false);
  const [descriptionText, setDescriptionText] = useState(true);

  const context = useContext(MainContext);
  const { plataformValidation } = context;

  React.useEffect(() => {
    if (validationKey) {
      setCodeLength(validationKey.digits || 0);
      if (plataformValidation) {
        setDescriptionText(
          <p>
            {validationKey.previous} <strong>{validationKey.key}</strong>{' '}
            {validationKey.next}.
          </p>
        );
      } else {
        setDescriptionText(
          <p>
            Solicite ao cliente os <strong>{validationKey.key}</strong>{' '}
            {validationKey.next}.
          </p>
        );
      }
    }
  }, [validationKey]);

  const handlePostData = () => {
    if (isEnabled) {
      setHasError(false);
      postData(ref.value).catch(() => {
        setHasError(true);
      });
    }
  };
  return (
    <Container>
      <CodeValidatorDescription
        fontSize={fontSize}
        style={{ textTransform: upperCase }}
      >
        {descriptionText}
      </CodeValidatorDescription>
      {validationKey && (
        <Form>
          <VerificationInput
            autoFocus
            length={codeLength}
            placeholder=""
            removeDefaultStyles
            container={{
              className: 'container',
            }}
            character={{
              className: 'input',
              classNameSelected: 'input-focused',
            }}
            inputField={{
              onChange() {
                if (ref.value.split('').length === codeLength) {
                  setAsEnabled(true);
                } else {
                  setAsEnabled(false);
                }
              },
            }}
            getInputRef={(inputRef) => setRef(inputRef)}
          />
          <UnblockButton
            width={width}
            type="submit"
            fontSize={fontSize}
            height={height}
            codeValidator={codeValidator}
            onClick={(event) => {
              event.preventDefault();
              handlePostData();
            }}
            isDisabled={!isEnabled}
          >
            {title}
          </UnblockButton>
          {hasError && (
            <ErrorInfo>
              Código incorreto. Verifique o valor e tente novamente.
            </ErrorInfo>
          )}
        </Form>
      )}
    </Container>
  );
};

CodeValidator.propTypes = {
  validationKey: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.bool,
  ]).isRequired,
  postData: PropTypes.func.isRequired,
};

export default CodeValidator;
